import { PAYMENT_METHOD, TRANSACTION_TYPES as TRANSACTION_TYPE } from 'components/constants';

export const toDto = (data) => ({
  paymentMethod: data.paymentMethod,
  amount: Number(data.amount),
  tariffs:
    data.commissions
      ?.filter((c) => c.amount && c.amount !== '')
      .map((c) => ({
        ...(c.tariffId ? { tariffId: c.tariffId } : {}),
        amount: Number(c.amount)
      })) || [],
  commentToAdmin: data.commentToAdmin,
  ...(data.transactionType === TRANSACTION_TYPE.OUTGOING
    ? {
        senderWallet: data.senderAccount?.wallet_number,
        recipient: toTransactionParty(data)
      }
    : {
        ...(data.recipientAccount
          ? { recipientWallet: data.recipientAccount.wallet_number }
          : { transferProvider: data.paymentProvider }),
        sender: toTransactionParty(data)
      })
});

export const fromErrorDto = (fields = {}) => ({
  amount: fields.amount,
  currency: fields.currency,
  commissions: fields.tariffs,
  comment: fields.comment,
  commentToAdmin: fields.commentToAdmin,
  senderAccount: fields.senderWallet,
  recipientAccount: fields.recipientWallet,
  paymentMethod: fields.paymentMethod,
  senderWalletAddress: fields.senderWalletAddress,
  recipientWalletAddress: fields.recipientWalletAddress
});

const toTransactionParty = (data) => {
  if (data.paymentMethod === PAYMENT_METHOD.INTERNAL) {
    return {
      walletNumber:
        data.transactionType === TRANSACTION_TYPE.INCOMING
          ? data.senderAccount?.wallet_number
          : data.recipientAccount?.wallet_number
    };
  } else {
    return {
      walletAddress:
        data.transactionType === TRANSACTION_TYPE.INCOMING ? data.senderWalletAddress : data.recipientWalletAddress
    };
  }
};
